export default {
    "fr": {
        "Title": "Double authentification",
        "Enable": "La double authentification est activée.",
        "Description": "Scannez le QR code avec votre application de double authentification.",
        "Disabled": "Désactiver la double authentification.",
        "Enabled": "Activer la double authentification",
        "RecoveryCodes": "Codes de récupération",
        "Code validation title": "Validation en deux étapes",
        "Validate": "Vérifier le code",
        "Verification code": "Code de vérification",
        "Invalide_code": "Code invalide",
        "Or recovery codes": "Ou entrez un code de récupération",
        "The provided two factor authentication code was invalid.": "Le code de vérification est invalide.",
        "Remember me": "Se souvenir de cet appareil pendant 30 jours"
    },
    "en": {
        "Title": "Two-Factor Authentication",
        "Enable": "Two-factor authentication is enabled.",
        "Description": "Scan the QR code with your authentication app.",
        "Disabled": "Disable two-factor authentication.",
        "Enabled": "Enable two-factor authentication",
        "RecoveryCodes": "Recovery Codes",
        "Code validation title": "Two-Factor Authentication Verification",
        "Validate": "Verify code",
        "Verification code": "Verify the code",
        "Invalide_code": "Invalid code",
        "Or recovery codes": "Or enter a recovery code",
        "The provided two factor authentication code was invalid.": "The provided two factor authentication code was invalid.",
        "Remember me": "Remember me on this device for 30 days"
    }
}
